import { useTrackMarketplaceEvent } from 'marketplace-ui-tracking';
import { getInstallButtonClickedEvent, getMarketplaceInteractionEvent, getPageViewedEvent } from 'marketplace-ui-tracking/events/marketplace';
export const SCREEN = 'listing details';
export const useTracking = ({
  companyName,
  listingId,
  sourceId,
  slug,
  type,
  appContext,
  embed,
  isPreview
}) => {
  const trackMarketplaceEvent = useTrackMarketplaceEvent();
  const trackInteraction = eventProps => {
    if (isPreview) {
      return;
    }
    trackMarketplaceEvent(getMarketplaceInteractionEvent(Object.assign({
      companyName,
      embed,
      inAppOrPublic: appContext === 'app' ? 'in-app' : 'public',
      listingId,
      screen: SCREEN,
      slug,
      sourceId: [sourceId],
      type
    }, eventProps)));
  };
  const trackInstall = eventProps => {
    if (isPreview) {
      return;
    }
    trackMarketplaceEvent(getInstallButtonClickedEvent(Object.assign({
      companyName,
      embed,
      inAppOrPublic: appContext === 'app' ? 'in-app' : 'public',
      listingId,
      screen: SCREEN,
      slug,
      sourceId: [sourceId],
      type
    }, eventProps)));
  };
  const trackPageViewed = () => {
    if (isPreview) {
      return;
    }
    trackMarketplaceEvent(getPageViewedEvent({
      companyName,
      embed,
      inAppOrPublic: appContext === 'app' ? 'in-app' : 'public',
      screen: SCREEN,
      slug,
      type
    }));
  };
  return {
    trackInstall,
    trackInteraction,
    trackPageViewed
  };
};